module.exports = __webpack_public_path__ + "static/img/ico_file_circle_exclamation.caf06e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_file_circle_exclamation.png
// module id = JvR7
// module chunks = 1